import React from 'react';
import { string, shape, func, number, bool } from 'prop-types';

import PayElementDropdown from '../../PayElementDropdown/PayElementDropdown';

import './SurveyJobMatchHeaders.scss';

class SurveyJobMatchesHeader extends React.PureComponent {
  static propTypes = {
    selectedPayElement: string,
    payElementLabels: shape({
      baseSalary: string,
      totalCash: string,
      totalTargetCash: string,
      totalDirect: string,
      totalGuaranteedPay: string,
      totalEmployeeCounts: number,
      totalCompanyCounts: number
    }),
    benchmarkYear: number,
    selectPayElement: func,
    showOverallComposites: bool
  };

  render() {
    const { selectedPayElement, payElementLabels, selectPayElement, benchmarkYear, showOverallComposites } = this.props;
    return (
      <div className="survey-job-matches__header">
        <h4 className="header-xxsmall">Original &amp; Unaged Data for Survey Job Matches</h4>
        <div className="survey-job-matches__header-dropdowns">
          <PayElementDropdown
            showOverallComposites={showOverallComposites}
            selectedPayElement={selectedPayElement}
            payElements={payElementLabels}
            onElementClick={selectPayElement}
            label={'Pay Elements'}
          />

          <div className="survey-job-matches__by">
            <p className="pxl-text-small">Benchmark Year</p>
            <h4>{benchmarkYear}</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyJobMatchesHeader;
